import { Input as InputComponent } from '../../Input'
import { INPUT_SELECT_SEARCH_INPUT_NAME } from '../Select.constants'
import { useSelectContext, useSelectFocusContext } from '../Select.hooks'
import { SelectControlEntityValueItem } from '../SelectControlEntityValueItem'

import * as styles from './InputSelectControlContent.module.css'

/**
 * Input select control content with selected item inside.
 * Can be used for single item select.
 */
function InputSelectControlContent({
  Input = InputComponent,
  ValueItem = SelectControlEntityValueItem,
  className = styles.InputSelectControlContent,
  inputProps,
  inputRef,
  valueItemProps,
}) {
  const { blocked, disabled, handleChangeSearch, searchValue, value } =
    useSelectContext()

  const { handleBlur, handleFocus } = useSelectFocusContext()

  return (
    <div className={className}>
      {ValueItem && value ? (
        <ValueItem
          {...valueItemProps}
          blocked={blocked}
          disabled={disabled}
          value={value}
        />
      ) : Input ? (
        <Input
          {...inputProps}
          blocked={blocked}
          name={inputProps?.name || INPUT_SELECT_SEARCH_INPUT_NAME}
          ref={inputRef}
          value={searchValue}
          onBlur={handleBlur}
          onChange={handleChangeSearch}
          onFocus={handleFocus}
        />
      ) : null}
    </div>
  )
}

export default InputSelectControlContent
